import { createStore } from 'vuex';
import authStore from './authStore';
import conversationStore from './conversationStore';
import authoringStore from './authoringStore';
import notificationStore from './notificationStore';
import auth0Store from './auth0Store';
import modalStore from './modalStore';
import translationStore from './translationStore';
import collectionStore from '~/store/collectionStore';
import documentStore from '~/store/documentStore';
import documentHistoryStore from '~/store/documentHistoryStore';
import platformNotificationsStore from '~/store/platformNotificationsStore';
import formFiltersStore from '~/store/formFiltersStore';
import quickPromptsStore from '~/store/quickPromptsStore';
import userImagesStore from '~/store/userImagesStore';

const store = createStore({
  modules: {
    auth0Store,
    authStore,
    conversationStore,
    authoringStore,
    collectionStore,
    documentStore,
    modalStore,
    notificationStore,
    translationStore,
    platformNotificationsStore,
    documentHistoryStore,
    formFiltersStore,
    quickPromptsStore,
    userImagesStore,
  },
});

export default store;
